import { STATE_BOUNDS } from '../constants/stateBounds';
import { TEMPERATURE_ORDER } from '../components/shared/temperatureConfig';
import { tagsApi } from './api';
import type { Tag } from '../types/tag';

export interface AxisOption {
  value: string;
  label: string;
}

const titleCase = (s: string) => s.charAt(0) + s.slice(1).toLowerCase();

export const US_STATES: AxisOption[] = Object.keys(STATE_BOUNDS)
  .sort()
  .map((c) => ({ value: c, label: c }));

export const NCES_LEVELS: AxisOption[] = ['High', 'Combined', 'Elementary', 'Middle'].map((v) => ({
  value: v,
  label: v,
}));

export const CUSTOMER_STATUS_OPTIONS: AxisOption[] = [
  'PROSPECT',
  'ONBOARDED',
  'ACTIVE',
  'SLIPPING',
  'LAPSED',
].map((v) => ({ value: v, label: titleCase(v) }));

export const STAGE_OPTIONS: AxisOption[] = ['LEAD', 'PROSPECT', 'CUSTOMER', 'CHURNED'].map((v) => ({
  value: v,
  label: titleCase(v),
}));

export const TEMPERATURE_OPTIONS: AxisOption[] = TEMPERATURE_ORDER.map((v) => ({
  value: v,
  label: titleCase(v),
}));

// Tag options are dynamic (user-defined), so they're fetched at filter-open time
// rather than baked in as a static const.
export async function loadTagOptions(): Promise<AxisOption[]> {
  const tags: Tag[] = await tagsApi.list();
  return tags.map((t) => ({ value: t.id, label: t.code }));
}
